import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbDataValueRenderer } from "abreact/data/AbDataValueRenderer";
import * as AbFormHooks from "abreact/form/AbFormHooks";
import { AbIntegerInput } from "abreact/input/AbIntegerInput";
import * as React from "react";
export function AbIntegerDataValueInput(props) {
  const editContext = AbFormHooks.useDataValueInputViewModel("ab-integer-data-value-input", props);
  if (!editContext) {
    return null;
  }
  const currentValue = editContext.currentValue;
  return !editContext.isEditing ? /*#__PURE__*/React.createElement(AbDataValueRenderer, _extends({}, editContext.readOnlyProps, {
    subject: props.subject,
    accessor: props.accessor,
    currentValue: props.currentValue
  })) : /*#__PURE__*/React.createElement(AbIntegerInput, _extends({}, editContext.inputProps, {
    value: currentValue ?? undefined,
    onChange: editContext.changeValue,
    min: props.min ?? props.accessor.constraints?.min,
    max: props.max ?? props.accessor.constraints?.max
  }));
}
//# sourceMappingURL=AbIntegerDataValueInput.js.map
